(function () {
    'use strict';

    angular.module("imApp").factory("emailAddService", ['$ihttp', 'p2DataTaskService', function ($ihttp, p2DataTaskService) {
        let service = {
            getInfo: function (parms) {
                return $ihttp.post({
                    method: 1118,
                    parameters: parms || {}
                });
            },
            loadEmailAddSuggestionList: function (info) {
                return p2DataTaskService.call(1119, info);
            },
            listSearchEmails: function (parms) {
                return $ihttp.post({
                    method: 1120,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
